import React from "react";

/**
 * TenantTrail official logo. uses the supplied PNG mark.
 * Different sizes are pre-rendered for crispness.
 */
export default function Logo({ size = 28, className = "" }) {
 // Pick the smallest pre-rendered size that's >= target for crisp rendering
 const src = size <= 48 ? "/logo-48.png" : size <= 96 ? "/logo-96.png" : size <= 192 ? "/logo-192.png" : "/logo-256.png";
 return (
 <img
 src={src}
 alt="TenantTrail"
 width={size}
 height={size}
 className={className}
 style={{ display: "inline-block", objectFit: "contain" }}
 />
 );
}

export function Wordmark({ size = 22, className = "" }) {
 return (
 <span
 className={`font-serif font-semibold tracking-tight ${className}`}
 style={{ fontSize: size, lineHeight: 1 }}
 >
 <span style={{ color: "#0D2B52" }}>Tenant</span>
 <span style={{ color: "#1B6C62" }}>Trail</span>
 </span>
 );
}
